import cookie from 'webmd-cookie';
import debug from 'webmd-debug';
import { ua } from 'webmd-useragent';

/*
 * Headerbidding integration for Magnite demand Prebid
 */
//Added prebid Experiment check for A/B Testing
if (typeof window !== 'undefined' && window.prebidExperiment) {

  let MAGDMD = {
    accountId: '16268',
    gptSlotObjects: [],
    slotData: {},
    activeAdsPos:[],
    refreshSlots:null,
    previousActiveAdsPos:[],
    prebidFromDisplay:false,

    // returns an array of pos's for slots we want Magnite to bid on
    getBidsPos: function(){
      if (ua.type === 'mobile') {
        return ["2025", "2026", "1923"];
      } else {
        return ["101", "113", "121", "137", "147", "141"];
      }
    },


    // checks if headerbidding is disabled via md=0 query parameter
    disableHeaderbidding: function() {
      return ((/[?&]md=0/).test(location.search) || window.location.href.indexOf('nobeacon') > -1 );
    },
      
    // load a script tag
    loadScript: function(tagSrc) {
      let 
      scriptTag = document.createElement('script'),
      placeTag = document.getElementsByTagName("script")[0];

      if (tagSrc.substr(0, 4) !== 'http') {
        let isSSL = true;
        tagSrc = (isSSL ? 'https:' : 'http:') + tagSrc;
      }

      scriptTag.type = 'text/javascript';
      scriptTag.src = tagSrc;
      scriptTag.async = true;
      placeTag.parentNode.insertBefore(scriptTag, placeTag);

      if (tagSrc.includes('prebid')) {
        /**
         * performance mark to spot when magnite code has started loading
         */
        try {
          window.performance.mark("magnite-load-start");
          window.performance.measure('measure-magnite-load-start', 'ads-code-load', 'magnite-load-start');
          debug('(Perf-Mark) Magnite load started -> ' + window.performance.getEntriesByName('measure-magnite-load-start', 'measure')[0].duration);
        } catch(e) {
          debug(e);
        }

        window.__loadPrebidPromise = new Promise(function(resolve, reject) {
          scriptTag.onload = function () {
            try {
              /**
               * performance mark to spot when magnite code has loaded
               */
              window.performance.mark('magnite-loaded');
              window.performance.measure('measure-magnite-loaded', 'ads-code-load', 'magnite-loaded');
              debug('(Perf-Mark) Magnite loaded -> ' + window.performance.getEntriesByName('measure-magnite-loaded', 'measure')[0].duration);
            } catch(e) {
              debug(e);
            }
            resolve();  
          };

          scriptTag.onerror = function(e) {
            window.webmd.createBeaconCall("webmd-vendor-flow","webmd-magnite", "webmd-magnite-load-failed");
            reject(e);
          };
        })
        .then(() => {
          debug('[MAGNITE] Prebid loaded successfully');
        })
        .catch(e => {
          debug('[MAGNITE] Prebid not loaded on error:', e);
        });
      }
    },

    loadWrapper: function() {
      let mdSrc = `//micro.rubiconproject.com/prebid/dynamic/${this.accountId}.js`;

      if (window.top === window.self) {
        // Load id5 api first and then load magnite so that magnite can pick id5userid
        if (window.webmd.id5) {
          Promise.resolve(window.webmd.id5.loadId5Promise).then(function() {
            MAGDMD.loadScript(mdSrc);
          });
        } else {
          MAGDMD.loadScript(mdSrc);
        }
      }
    },

    prebidCallback: function(slots) {
     if(window.webmd && window.webmd.ads && window.webmd.ads.magdmdPrebidObj&& window.webmd.ads.magdmdPrebidObj.adRequestCall){
      //sends the ads call request to the pbjs callback method to make ad call
      webmd.ads.magdmdPrebidObj.adRequestCall();
    }
    },

    // get the prebids
    getPrebids: function () {

      // to store refresh setting value for prebids 
    

      if (this.prebidFromDisplay) {
        this.prebidFromDisplay = false;
        return
      }
      let mappings = this.getBidsPos();
      let gptSlots = googletag.pubads().getSlots();
      let pbTimeout = 3500; // timeout

      if (typeof window.pbjs === 'undefined') {
        debug('[MAGNITE] Prebid is undefined');
        return;
      }


      if (gptSlots.length < 1) {
        return; // no ad slots on this page
      }
      //return if prebid has been
      // if (this.bidsRequested) {
      //   console.log("requestBids has already been called");
      //   return;
      // }
      this.bidsRequested = true;
      /*
       * create the bid requests based on slots we want Magnite demand to bid on
       */
      this.gptSlotObjects = [];
      for (let i = 0; i < gptSlots.length; i++) {
        let ad = gptSlots[i];
        if (mappings.indexOf(ad.getTargeting('pos')[0]) > -1) {
          this.gptSlotObjects.push(ad);
        }
      }

      let slotObjects = this.gptSlotObjects;

      this.activeAdsPos = [];
      if (slotObjects.length !== 0) {
        slotObjects.map((val) => {
          this.activeAdsPos.push(val.getSlotId().getDomId())
        })
      }

      /*
       * if prebid is called from refresh ad function check for pos,id,posSkip and idSkip value and call the prebid function
        */
      if (this.refreshSlots) {
      /*
       * if prebid is called from refresh and refresh has a pos values which need to be refreshed
        */

      //if pos value is an object  i.e ({pos:{101:true,121:true}})
    
        if (this.refreshSlots.pos && typeof this.refreshSlots.pos == "object") {

          // posToBeRefreshed stores the pos values which need to be refreshed
          // posTarget stores the pos values using getTargeting method for each slotObjects
          let posToBeRefreshed = [], posTarget = [];
          for (let key in this.refreshSlots.pos) {
            if (this.refreshSlots.pos[key] == true) {
              posToBeRefreshed.push(key)
            }
          }
          slotObjects.forEach(val => {
            posTarget = [...posTarget, ...val.getTargeting("pos")]
          }
          )
          // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val, i) => {
            // checks whether the pos which need to be refreshed is available in the current slotObject and using posTarget
            if (posToBeRefreshed.includes(posTarget[i])) {
              slotObjects.push(val)
            }
          })
        }

        //if pos value is not an object i.e (pos:"101")
        else if (this.refreshSlots.pos && typeof this.refreshSlots.pos !== "object") {
            // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val) => {
              // checks whether the pos which need to be refreshed is available in the current slotObject
            if (val.getTargeting("pos").includes(this.refreshSlots.pos)) {
              slotObjects.push(val)
            }
          })
        }

           /*
       * if prebid is called from refresh and refresh has a pos values which need to be refreshed
        */

    //if id value is an object  i.e ({id:{ad-pos-101-1:true,ad-pos-101-2:true}})
        else if (this.refreshSlots.id && typeof this.refreshSlots.id == "object") {
           // posToBeRefreshed stores the id values which need to be refreshed
          // posTarget stores the id values using getSlotId().getDomId() method for each slotObjects
          let posToBeRefreshed = [], posTarget = [];
          for (let key in this.refreshSlots.id) {
            if (this.refreshSlots.id[key] == true) {
              posToBeRefreshed.push(key)
            }
          }
          slotObjects.forEach(val => {
            posTarget = [...posTarget, val.getSlotId().getDomId()]
          }
          )
            // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val, i) => {
              // checks whether the id which need to be refreshed is available in the current slotObject and using posTarget
            if (posToBeRefreshed.includes(posTarget[i])) {
              slotObjects.push(val)
            }
          })
        }

          //if id value is not an object  i.e ({id:"ad-pos-101-1"})
        else if (this.refreshSlots.id && typeof this.refreshSlots.id !== "object") {
             // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val) => {
                // checks whether the id which need to be refreshed is available in the current slotObject and using posTarget
            if (val.getSlotId().getDomId().includes(this.refreshSlots.id)) {
              slotObjects.push(val)
            }
          })
        }

          //if posSkip value is an object  i.e ({posSkip:{101:true,121:true}})
        else if (this.refreshSlots.posSkip && typeof this.refreshSlots.posSkip == "object") {
            // posToBeRefreshed stores the pos values which doesn't need to be refreshed
          // posTarget stores the pos values using getTargeting method for each slotObjects
          let posToBeRefreshed = [], posTarget = [];
          for (let key in this.refreshSlots.posSkip) {
            if (this.refreshSlots.posSkip[key] == true) {
              posToBeRefreshed.push(key)
            }
          }
          slotObjects.forEach(val => {
            posTarget = [...posTarget, ...val.getTargeting("pos")]
          }
          )
           // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val, i) => {
               // skips the pos values which doesn't need to be refreshed and add rest to the slotObjects
            if (!posToBeRefreshed.includes(posTarget[i])) {
              slotObjects.push(val)
            }
          })
        }
        else if (this.refreshSlots.posSkip && typeof this.refreshSlots.posSkip !== "object") {
             // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val) => {
                // skips the pos values which doesn't need to be refreshed and add rest to the slotObjects
            if (!val.getTargeting("pos").includes(this.refreshSlots.posSkip)) {
              slotObjects.push(val)
            }
          })
        }

        //if id value is an object  i.e ({idSkip:{ad-pos-101-1:true,ad-pos-101-2:true}})
        else if (this.refreshSlots.idSkip && typeof this.refreshSlots.idSkip == "object") {
             // posToBeRefreshed stores the id values which doesn't need to be refreshed
          // posTarget stores the id values using getSlotId().getDomId() method for each slotObjects
          let posToBeRefreshed = [], posTarget = [];
          for (let key in this.refreshSlots.idSkip) {
            if (this.refreshSlots.idSkip[key] == true) {
              posToBeRefreshed.push(key)
            }
          }
          slotObjects.forEach(val => {
            posTarget = [...posTarget, val.getSlotId().getDomId()]
          }
          )
            // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val, i) => {
              // skips the id values which doesn't need to be refreshed and add rest to the slotObjects
            if (!posToBeRefreshed.includes(posTarget[i])) {
              slotObjects.push(val)
            }
          })
        }
        else if (this.refreshSlots.idSkip && typeof this.refreshSlots.idSkip !== "object") {
            // previousSlotObject act as temp variable for slotObjects 
          let previousSlotObject = slotObjects;
          slotObjects = [];
          previousSlotObject.forEach((val) => {
              // skips the id values which doesn't need to be refreshed and add rest to the slotObjects
            if (!val.getSlotId().getDomId().includes(this.refreshSlots.idSkip)) {
              slotObjects.push(val)
            }
          })
        }

      }

   /*
       * if prebid is not called from refresh ad function update the slot for which the prebid function need to be called
        */
      else {
        //find if there is any new add which is lazyloaded 
        const uniqueAdsPos = this.activeAdsPos.filter(pos => !this.previousActiveAdsPos.includes(pos));
        if (this.previousActiveAdsPos.length == 0 && webmd.ads.initialLoadDisabled) {
          return
        }

       
        else if (uniqueAdsPos.length == 0 && this.previousActiveAdsPos.length !== 0) {
          console.log('No new unique active ad positions.');
          return

        }

        // filter the slot object based on uniqueAdsPos
        else if (uniqueAdsPos.length > 0 && this.previousActiveAdsPos.length !== 0) {
          slotObjects = slotObjects.filter(val => uniqueAdsPos.includes(val.getSlotId().getDomId()))
        }

      }
      this.refreshSlots = null;

      // previousActiveAdsPos help us to keep the track of previous active slot for whom the prebid is already called
      this.previousActiveAdsPos = this.activeAdsPos;

      // request pbjs bids when it loads
      pbjs.que.push(() => {
        // if bids have been fetched already, return
        // if (pbjs.bidsFetched) {
        //   console.log("bids have already been fetched");
        //   return;
        // }

        debug('[MAGNITE] Prebid Request data: ', MAGDMD);
        pbjs.rp.requestBids({
          callback: this.prebidCallback.bind(this),
          gptSlotObjects: slotObjects
        });

   
      });

      // failsafe in case PBJS doesn't load
      // setTimeout(() => {
      //   this.prebidCallback(slotObjects);
      // }, pbTimeout);

    },
    shouldRemoveAds: function()
    {
      // Check if window.location and window.location.search are defined
       if (typeof window !== 'undefined' && window.location) {
            return window.location.href.indexOf('conmktvid') > -1;
        }
        return false; // Return false if the checks fail
    }
  }

  document.addEventListener('refreshForMagnite', (event) => {
    if (event && event.detail) {
      MAGDMD.refreshSlots = event.detail
      //slots will be here
    }
  })

  // to check if prebid is called from display ad function
  document.addEventListener('prebidForDisplay', () => {
    MAGDMD.prebidFromDisplay = true
  })
  // setup googletag
  window.googletag = window.googletag || {};
  googletag.cmd = googletag.cmd || [];
  googletag.cmd.push(function() {
    googletag.pubads().disableInitialLoad();
  });

  // initialize the third party service namepace, command queue and promises queue
  window.tpsvc = window.tpsvc || {};

  // The ads code will execute every command inside this queue before an ad request is made
  window.tpsvc.cmds = window.tpsvc.cmds || [];

  (function() {

  		// Disable vendor if url containts vendor=0 or magnitedemand=0
  		var url = (document.referrer) ? document.referrer : document.location.href;
      if (url && (url.indexOf('vendor=0') > -1 || url.indexOf('md=0') > -1)) {
        return false;
      }

    // Disable vendor based on ads admin tool data
    if(window.globalConfig && window.globalConfig.ads) {

      let vendorConfig = window.globalConfig.ads.vendorConfig;
      let magniteConfig = vendorConfig.magnite ? vendorConfig.magnite : {};
      let location = cookie.getJson('gtinfo');
			
      /**
       *  Gtinfo cookie stores country code in lowercase while admin tool db stores in uppercase
       *  hence text transform is done.
       */
      let isLocationAdded = false;
      let countryCode = location.cntr ? location.cntr.toUpperCase() : '';
      let locationList = magniteConfig.location ? magniteConfig.location : [];
                                                                                                                                    
      /** 
       *  If the gtinfo is not available and only some of the locations are selelcted, 
       *  location based vendor suppression cannot be done properly. Hence, vendors can be loaded 
       *  as default behavior. 
       * 
       *  If location property is undefined or no countries are added in location array 
       *  or all the countries are selected, then it can be considered as 
       *  all the locations are selected and not required to check for gtinfo.
       *  Countries available in WebMD gtinfo file : 249
       */
      if ( !(countryCode == '' && locationList.length > 0 && locationList.length < 249) ) {
        if ( locationList.length == 0 || locationList.length == 249 || locationList.includes(countryCode) ) {
          isLocationAdded = true;
        }
        /**
         *  If disable is true and the location is included in the location array, 
         *  then vendor should not be loaded.   
         *  If disable is set to false and certain countries are added in location array, 
         *  then for the countries that are not added in the array can be considered 
         *  to have disable : true and vendor should not be loaded in this case. 
         */
        if (magniteConfig.disable && isLocationAdded) {
          return false;
        } else if ( !(magniteConfig.disable) && !isLocationAdded ) {
          return false;			
        }
      }
    }

    // if in iframe exit immediately;
    if (window.top !== window.self) {
      return;
    }

    // if we are on sensitive topic pages 
    if (window.s_sensitive && window.s_sensitive === "true") {
      return;
    }

    // if we are on fit, labs, member or webmdrx page, return immediately
    if ( (/member.|fit.|labs.|webmdrx\./).test(location.host)) {
      return;
    }

    // if we are on a funded page, return immediately
    if (window.s_sponsor_brand && window.s_sponsor_brand.length > 0) {
      return;
    }

    // Applies only for WebMD domain
    if (!window.location.href.includes('webmd.com')) {
      return;
    }

    // if user visits through medscape.com, return immediately
    if (window.document.referrer.includes('medscape.com')) {
      return;
    }

    // Enable magnite for Care profile pages based on specialty
    if (window.location.href.includes('/doctor/')) {
      const blockSpecialtyIds = new Set(['29285', '29313', '29326', '29245', '29261']);
      let initialState = window.__INITIAL_STATE__;
      if ( initialState && initialState.profile && initialState.profile.specialites ) {
        let specialties = initialState.profile.specialites;
        const hasBlockedSpecialty = specialties.some(({ Id }) => blockSpecialtyIds.has(Id));
        if (hasBlockedSpecialty) return;
      } 
    }

    // initialize pbjs
    window.pbjs = window.pbjs || {};
    pbjs.que = pbjs.que || [];

    // if (!window.s_contains_video && !MAGDMD.disableHeaderbidding()) {
    //   /**
    //      * we need to load Magnite Demand once __tcfapiPromise is resolved,
    //      * the Promise is resolved once tcfapi.js is loaded onto the page
    //      * 
    //      * tcfapi.js is loaded only in EU locations and in other locations the Promise is
    //      * resolved immediately (handled in IAB stub code - webmd-ccm.js)
    //      * 
    //     */
    //     Promise.resolve(window.__tcfapiPromise).then(function () {
    //       MAGDMD.loadWrapper();

    //      /*
    //       * queue the prebid request.
    //       * This will be executed in the future, just before the webmd ad request is made
    //       */
    //       window.tpsvc.cmds.push(MAGDMD.getPrebids.bind(MAGDMD));

    //     });
    // }
    if (!window.s_contains_video && !MAGDMD.disableHeaderbidding()) {
      function startMagenite() {
        /**
         * we need to load Magnite Demand once __tcfapiPromise is resolved,
         * the Promise is resolved once tcfapi.js is loaded onto the page
         * 
         * tcfapi.js is loaded only in EU locations and in other locations the Promise is
         * resolved immediately (handled in IAB stub code - webmd-ccm.js)
          * 
          */
          Promise.resolve(window.__tcfapiPromise).then(function () {
            MAGDMD.loadWrapper();

            /*
            * queue the prebid request.
            * This will be executed in the future, just before the webmd ad request is made
            */
            window.tpsvc.cmds.push(MAGDMD.getPrebids.bind(MAGDMD));
          });
        }
        Promise.resolve(window.tugEvalPromise).then(function(sponsor){
          if(sponsor){
            return;
          }else if(MAGDMD.shouldRemoveAds()){
            return;
          }
          else{
            startMagenite()
          }
        });
      }

  })();
}
